import { render } from "./breakdown.vue?vue&type=template&id=9e48334c&scoped=true"
import script from "./breakdown.vue?vue&type=script&lang=js"
export * from "./breakdown.vue?vue&type=script&lang=js"

import "./breakdown.vue?vue&type=style&index=0&id=9e48334c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e48334c"]])

export default __exports__